import * as Yup from "yup";

export const globalDiscountValidation = Yup.object().shape({
  percent: Yup.number()
    .typeError("درصد باید عدد باشد")
    .min(0, "درصد باید بین ۰ تا ۱۰۰ باشد")
    .max(100, "درصد باید بین ۰ تا ۱۰۰ باشد")
    .required("وارد کردن درصد الزامی است"),
});
